import React from "react";
import { Container, Row, Col, Card, Button, Image } from "react-bootstrap";
import Header from "../Helper/Header";
import NewFooter from "../Helper/NewFooter";
import ContactForm from "../ContactForm/ContactForm";
import { BASE_URL } from "../../constants";

const NewsPage = () => {
  const news = [
    {
      id: "Dsider x CORYS Partnership",
      image: "news/dsider_main_news.png",
      title: "Dsider x CORYS Partnership",
      text: "We are thrilled to announce a strategic partnership between CORYS and Dsider, marking...",
    },
    {
      id: "analytics-shaping-the-future-of-energy-transition",
      image: "news/recent_news_1.png",
      title: "Analytics Shaping the Future of Energy Transition",
      text: "Thanks to Sujatha Kumar with Dsider for joining Mike on #TheGreenInsider. Founder and CEO of Dsider joins us on eRENEWABLE and TheGreen.",
    },
    {
      id: "empowering-sustainability-through-digital-innovation",
      image: "news/recent_news_2.png",
      title: "Empowering Sustainability through Digital Innovation",
      text: "We are pleased to share that Sujatha Kumar, Founder and CEO, Dsider.",
    },
    {
      id: "musings-on-netzero-planning-1",
      image: "news/recent_news_3.png",
      title: "Musings on Netzero Planning - #1",
      text: "With mixed results on climate action, A new year always offers hope for.",
    },
  ];

  const limitText = (text) => {
    return text.length > 150 ? text.substring(0, 90) + "..." : text.substring(0, 90);
  };

  const handleReadMore = (blog) => {
    const url = `/news/${blog.id}`;
    window.open(url, "_blank");
  };

  return (
    <div>
      <Header />
      <Container className="news-page">
        <Row className="text-center my-5">
          <Col>
            <div className="news-heading">Dsider News</div>
            <img
              src={`${BASE_URL}common-images/mask_image.png`}
              alt="Mask"
              className="mask-image-news"
            />
          </Col>
        </Row>

        <Row className="text-center my-4">
          <Col>
            <Image
              src={`${BASE_URL}news/CERAWeek_Speaker_Post.png`}
              alt="Dsider News"
              fluid
              className="news-image"
              style={{ width: "850px", height: "501px" }}
            />
          </Col>
        </Row>

        <Row className="my-4">
          <Col>
            <div className="news-subheading">
              CERAWeek agora : Speaker Announcement
            </div>
            <p className="news-text">
            Our CEO, Sujatha Kumar will be speaking at CERAWeek!
Join her and Graham Provost as they discuss an important and timely topic to drive Sustainable Projects forward. <br/>
Don't miss this insightful conversation with industry leaders shaping the future. <br/> <br/>
📅 Thursday, March 13th at 3PM (POD 3) <br/> <br/>
            </p>
          </Col>
        </Row>

        {/* <Row className="my-5">
          <Col md={4} className="d-flex align-items-center">
            <Image
              src={`${BASE_URL}news/dsider_sub_news.png`}
              alt="Dsider News 1"
              fluid
              className="news-grid-image"
            />
          </Col>
          <Col md={8} className="d-flex align-items-center">
            <p className="news-text2">
              This MoU signifies a shared commitment to combining cutting-edge
              expertise in real-time dynamic process modeling with
              state-of-the-art techno economic decision intelligence, ensuring
              our clients achieve unparalleled efficiency, safety, and returns
              for new energy projects.
              <br />
              Together, Dsider and CORYS will empower industries to make
              smarter, faster, and more informed decisions with scalable,
              integrated solutions. Stay tuned for updates as we bring this
              partnership to life.
              <br /> The Future of Intelligent Operations Begins Today!
            </p>
          </Col>
        </Row> */}

        <div className="d-flex justify-content-center align-items-center mb-4">
          <h1 className="news-heading mb-0">Recent News</h1>
        </div>
        <Row xs={1} md={3} lg={3} className="g-3">
          {news.map((blog) => (
            <Col key={blog.id}>
              <Card className="h-100 blog-card mx-auto">
                <Card.Img
                  variant="top"
                  src={`${BASE_URL}${blog.image}`}
                  className="blog-image my-3"
                  style= {{ borderRadius: "10px", height: "280px", objectFit: "cover", objectPosition: "left" }}
                />
                <Card.Body className="d-flex flex-column card-body-custom text-start">
                  <Card.Title className="blogtitle">{blog.title}</Card.Title>
                  <Card.Text className="blogtext">
                    {limitText(blog.text)}
                  </Card.Text>
                  <Button
                    className="mt-auto align-self-center z-btn-blog z-btn-3-blog"
                    onClick={() => handleReadMore(blog)}
                  >
                    Read More
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
      <ContactForm showHeader={false} showFooter={false}/>
      <NewFooter />
    </div>
  );
};

export default NewsPage;